module.exports = __webpack_public_path__ + "img/k16.ca4def27.jpg";